import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Stack,
  Heading,
  Text,
  HStack,
  VStack,
} from "@chakra-ui/react";
import Image from "next/image";
import RenderBuyNow from "../components/renderBuyNow";
import { useSortData } from "../hooks/useSortData";
import { getSelectedPrice } from "../utils/getSelectedPrice";
import { FrequencyType, OperatingSystemType, PlanType } from "@/types/pricing";
import { OS_IMAGES } from "./constants";

type Props = {
  plans: PlanType[];
  selectedOS: OperatingSystemType;
  selectedFrequency: FrequencyType;
  sortField: string;
  sortOrder: "asc" | "desc";
};

export const DesktopView = (props: Props) => {
  const { plans, selectedOS, selectedFrequency, sortField, sortOrder } = props;
  const sortedPlans = useSortData(plans, [sortField], [sortOrder]);

  return (
    <Box>
      <Table variant="striped" border={"2px solid rgb(237,242,247)"}>
        <Thead>
          <Tr>
            <Th>Type</Th>
            <Th>vCPU</Th>
            <Th>Memory</Th>
            <Th>SSD/NVME</Th>
            <Th>Price</Th>
            <Th>Buy Now</Th>
          </Tr>
        </Thead>
        <Tbody>
          {sortedPlans.map((plan, index) => (
            <Tr key={index}>
              <Td>
                <HStack spacing={1}>
                  <Box h="2rem" position="relative" w="3rem">
                    <Image
                      alt={selectedOS.name}
                      fill
                      sizes="33px"
                      src={OS_IMAGES[selectedOS.id]}
                      style={{ objectFit: "contain" }}
                    />
                  </Box>
                  <Text>{plan.name}</Text>
                </HStack>
              </Td>
              <Td>{plan.config.vcpu}</Td>
              <Td>
                {plan.config.memory} {plan.config.memory_unit}
              </Td>
              <Td>
                {plan.config.ssd} {plan.config.ssd_unit}
              </Td>
              <Td fontSize={"20px"} fontWeight={"bold"} color="brand.100">
                $
                {Math.round(
                  getSelectedPrice(plan.prices, selectedFrequency) +
                    getSelectedPrice(selectedOS.prices, selectedFrequency)
                )}
              </Td>
              <Td>
                {
                  <RenderBuyNow
                    product="Cloud-Instances"
                    plan={plan.id}
                    selectedFrequency={selectedFrequency.value}
                    selectedOS={selectedOS.id}
                  />
                }{" "}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export const MobileView = (props: Props) => {
  const { plans, selectedOS, selectedFrequency, sortField, sortOrder } = props;
  const sortedPlans = useSortData(plans, [sortField], [sortOrder]);
  return (
    <Stack spacing={4}>
      {sortedPlans.map((plan, index) => (
        <VStack
          borderColor={"gray.300"}
          key={index}
          borderRadius="5px"
          borderWidth="1px"
          spacing={4}
          p={4}
        >
          <HStack spacing={2}>
            <Box h="3rem" position="relative" w="2rem">
              <Image
                alt="image"
                fill
                sizes="33px"
                src={OS_IMAGES[selectedOS.id]}
                style={{ objectFit: "contain" }}
              />
            </Box>
            <Text fontWeight="700" fontSize={"20px"}>
              {plan.name}
            </Text>
          </HStack>
          <HStack spacing={1}>
            <Text fontSize={"15px"}>vCPU : </Text>
            <Heading fontSize="20px">{plan.config.vcpu}</Heading>
          </HStack>
          <HStack spacing={1}>
            <Text fontSize={"15px"}>Memory : </Text>
            <Heading fontSize="20px">
              {plan.config.memory} {plan.config.memory_unit}
            </Heading>
          </HStack>
          <HStack spacing={1}>
            <Text fontSize={"15px"}>SSD/NVME : </Text>
            <Heading fontSize="20px">
              {plan.config.ssd} {plan.config.ssd_unit}
            </Heading>
          </HStack>
          <HStack spacing={1}>
            <Text fontSize={"15px"}>Price : </Text>
            <Heading fontSize="20px" color="brand.100">
              $
              {Math.round(
                getSelectedPrice(plan.prices, selectedFrequency) +
                  getSelectedPrice(selectedOS.prices, selectedFrequency)
              )}
            </Heading>
          </HStack>
          {
            <RenderBuyNow
              product="Cloud-Instances"
              plan={plan.id}
              selectedFrequency={selectedFrequency.value}
              selectedOS={selectedOS.id}
            />
          }
        </VStack>
      ))}
    </Stack>
  );
};
